import React from "react";

const NameOfACompany = () => {
  return <div>NameOfACompany</div>;
};

export default NameOfACompany;
